<template>
<div class="legend-ctrl-btn-group">
  <slot name="toolbar-before" />
  <el-button v-if="getChart" size="mini" type="danger" @click="onClearBtnClick">清空</el-button>
  <slot name="toolbar" />
  <el-button v-if="getDownloadWrapper" size="mini" type="success" @click="onExportBtnClick">导出</el-button>
  <slot name="toolbar-after" />
</div>
</template>

<script>
import html2canvas from 'html2canvas'

export default {
  name: 'ChartCtrlBtnGroup',
  props: {
    getChart: {
      type: Function
    },
    getDownloadWrapper: {
      type: Function
    },
    maxLegendNum: {
      type: Number
    }
  },
  methods: {
    onSelectAllBtnClick () {
      let {selected, chart, render} = this.getChart()
      let chartOpt = chart.getOpt()

      if (chartOpt) {
        for (let key in selected) {
          selected[key] = true
        }

        render()
      }
    },
    onInvertSelectBtnClick () {
      let {selected, chart, render} = this.getChart()
      let chartOpt = chart.getOpt()

      if (chartOpt) {
        for (let key in selected) {
          selected[key] = !selected[key]
        }

        render()
      }
    },
    onClearBtnClick () {
      let {selected, chart, render} = this.getChart()
      let chartOpt = chart.getOpt()

      if (chartOpt) {
        for (let key in selected) {
          selected[key] = false
        }

        render()
      }
    },
    onExportBtnClick () {
      let {downloadWrapper, downloadName} = this.getDownloadWrapper()
      html2canvas(downloadWrapper, {
        logging: true,
        allowTaint: true,
        useCORS: true,
        scale: 1
      }).then(canvas => {
        canvas.toBlob(blob => {
          let url = URL.createObjectURL(blob)
          let link = document.createElement('a')
          link.download = `${downloadName}.png`
          link.href = url
          link.click()
          URL.revokeObjectURL(url)
        })
      })
    }
  }
}
</script>

<style lang="scss">
.legend-ctrl-btn-group {
  display: flex;
  gap: 10px;
  margin: 0;

  .el-button {
    margin: 0!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DataChart/ChartCtrlBtnGroupV2.vue